import { ImageViewModel } from '@/src/shared/presentation/view-models/image.viewModel';

import { TextFieldViewModel } from '../text-field.viewModel';

import type { ICMSBlockViewModel } from '../../types/cms-block.viewModel';
import type { TextImageBlock } from '@/src/cms/domain/models/blocks/text-image-block';

export class TextImageBlockViewModel implements ICMSBlockViewModel {
  readonly $type = 'text-image-block' as const;

  body: TextFieldViewModel;
  title: string;
  image: ImageViewModel;
  layout: 'left' | 'right';

  constructor(data: {
    title: string;
    body: TextFieldViewModel;
    image: ImageViewModel;
    layout: 'left' | 'right';
  }) {
    this.body = new TextFieldViewModel(data.body);
    this.title = data.title;
    this.image = new ImageViewModel(data.image);
    this.layout = data.layout;
  }

  static presenter(block: TextImageBlock): TextImageBlockViewModel {
    return new TextImageBlockViewModel({
      title: block.title,
      body: TextFieldViewModel.presenter(block.body),
      image: ImageViewModel.presenter(block.image),
      layout: block.layout
    });
  }
}
